import React, { useEffect } from 'react';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';

import './Gallery.scss';
import { EggTab, EggTabs } from 'components/Egg/EggTabs';
import { routes } from 'routing/routes';
import { Outlet } from 'react-router-dom';

const GalleryView = () => {
  useEffect(() => {
    const offcanvasBackdrop = document.querySelector('.offcanvas-backdrop');
    // The backdrop does not close manually on mobile, so we have to do it
    // manually here. We do not have access to the bootstrap global object
    // so we must manually click the dusknav to dismiss it.
    if (offcanvasBackdrop && offcanvasBackdrop.classList.contains('show')) {
      (document.querySelector('button[data-bs-target="#dusknav"]') as HTMLElement)?.click();
    }
  }, []);

  const tabs: EggTab[] = [
    {
      name: 'Breakers',
      link: routes.gallery.base(),
      controls: 'breakers',
      id: 'breakers-tab',
    },
    {
      name: 'Gribbles',
      link: routes.gallery.eggs(),
      controls: 'gribbles',
      id: 'gribble-tab',
    },
  ];

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="gallery"
    >
      <Helmet>
        <title>Gallery - DuskBreakers</title>
        <meta
          name="description"
          content="Explore the universe of DuskBreakers and learn more about life as a Breaker."
        />
      </Helmet>

      <section className="breakerGallery">
        <div>
          <h1 className="h3">Gallery</h1>
          <p className="description">
            Sort through the collection with filters by different attributes.
          </p>
        </div>
        <EggTabs tabs={tabs} />
        <div className="gallery-view">
          <Outlet />
        </div>
      </section>
      <Footer />
    </m.main>
  );
};

export default GalleryView;
